const doc = [({"en":({"adminConstantCompanyAdminUserRoleType":({"admin":"Administrator", "facilityAdmin":"Facility administrator", "facilityOperator":"Facility operator"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;